import Vue from 'vue';
import Component from 'vue-class-component';
import template from './disclaimer.html';

@Component({
	template: template,
})
export class Disclaimer extends Vue {}
